import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { Lang } from '@debbie/common/dist/lang/Lang.js';
import THEME from '../theme.js';
import CzechishFlag from './Icons/CzechishFlag.js';
import DanishFlag from './Icons/DanishFlag.js';
import DutchFlag from './Icons/DutchFlag.js';
import FinnishFlag from './Icons/FinnishFlag.js';
import FrenchFlag from './Icons/FrenchFlag.js';
import GermanFlag from './Icons/GermanFlag.js';
import GreekFlag from './Icons/GreekFlag.js';
import NorwegianFlag from './Icons/NorwegianFlag.js';
import SpanishFlag from './Icons/SpanishFlag.js';
import SwedishFlag from './Icons/SwedishFlag.js';
import UnitedKingdomFlag from './Icons/UnitedKingdomFlag.js';
const availableLanguages = [
    Lang.en,
    Lang.da,
    Lang.sv,
    Lang.no,
    Lang.fi,
    Lang.nl,
    Lang.de,
    Lang.fr,
    Lang.es,
    Lang.cs,
    Lang.el,
];
const languageIconMap = {
    [Lang.en]: UnitedKingdomFlag,
    [Lang.da]: DanishFlag,
    [Lang.sv]: SwedishFlag,
    [Lang.no]: NorwegianFlag,
    [Lang.fi]: FinnishFlag,
    [Lang.nl]: DutchFlag,
    [Lang.de]: GermanFlag,
    [Lang.fr]: FrenchFlag,
    [Lang.es]: SpanishFlag,
    [Lang.cs]: CzechishFlag,
    [Lang.el]: GreekFlag,
};
const languages = availableLanguages.map((l) => {
    const icon = languageIconMap[l];
    if (!icon)
        throw `Please provide an icon for language ${l}`;
    return {
        lang: l,
        icon,
    };
});
export const LanguageInput = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement("div", null, languages
        .filter((l) => {
        if (!props.availableLanguages)
            return true;
        return props.availableLanguages.includes(l.lang);
    })
        .map((l) => {
        const Flag = l.icon;
        return (React.createElement(Language, { active: l.lang === props.language, "data-tooltip-id": "tooltip-default", "data-tooltip-content": 
            // @ts-ignore
            lang.langs[l.lang], key: l.lang, disabled: props.disabled },
            React.createElement(Flag, { onClick: () => !props.disabled && props.onChange && props.onChange(l.lang) })));
    })));
};
export default LanguageInput;
const Language = styled.div `
  display: inline-block;
  margin-right: 5px;
  border-radius: 100%;
  height: 24px;
  width: 24px;

  svg {
    ${(props) => (props.disabled ? '' : 'cursor: pointer;')}
    height: 20px;
    padding: 2px;
  }

  border: 2px solid
    ${(props) => props.active ? `${THEME.COLOR_ACCENT}ff` : `${THEME.COLOR_ACCENT}00`};

  transition: border 0.2s;
`;
//# sourceMappingURL=LanguageInput.js.map